(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DURATION = 320;
    var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function FaqItem(el, group) {
      this.el = el;
      this.group = group;
      this.summary = el.querySelector('.faq__question');
      this.animation = null;
      this.isClosing = false;

      // The script owns exclusivity from here on, so the native `name`
      // grouping cannot slam the previous answer shut mid-animation.
      el.removeAttribute('name');
      this.summary.addEventListener('click', this.onClick.bind(this));
    }

    // Height the element settles at with only the summary showing.
    FaqItem.prototype.closedHeight = function () {
      var borders = this.el.offsetHeight - this.el.clientHeight;
      return this.summary.offsetHeight + borders;
    };

    // Height it wants when fully open, measured with a real layout pass so
    // borders and box-sizing are accounted for.
    FaqItem.prototype.openHeight = function () {
      var previous = this.el.style.height;
      this.el.style.height = 'auto';
      var height = this.el.offsetHeight;
      this.el.style.height = previous;
      return height;
    };

    FaqItem.prototype.onClick = function (event) {
      event.preventDefault();

      if (reducedMotion()) {
        this.el.open = !this.el.open;
        if (this.el.open) this.group.closeOthers(this);
        return;
      }

      if (this.isClosing || !this.el.open) {
        this.expand();
      } else {
        this.shrink();
      }
    };

    FaqItem.prototype.expand = function () {
      var self = this;

      this.el.style.height = this.el.offsetHeight + 'px';
      this.el.open = true;
      this.group.closeOthers(this);

      window.requestAnimationFrame(function () {
        self.animate(self.el.offsetHeight, self.openHeight(), true);
      });
    };

    FaqItem.prototype.shrink = function () {
      this.isClosing = true;
      this.animate(this.el.offsetHeight, this.closedHeight(), false);
    };

    FaqItem.prototype.animate = function (from, to, willBeOpen) {
      var self = this;

      if (this.animation) {
        // Drop the handlers before cancelling: oncancel fires asynchronously
        // and would otherwise reset the state of the animation replacing it.
        this.animation.onfinish = null;
        this.animation.oncancel = null;
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        { height: [from + 'px', to + 'px'] },
        { duration: DURATION, easing: EASING }
      );

      this.animation.onfinish = function () {
        self.el.open = willBeOpen;
        self.reset();
      };

      this.animation.oncancel = function () {
        self.reset();
      };
    };

    FaqItem.prototype.reset = function () {
      this.animation = null;
      this.isClosing = false;
      this.el.style.height = '';
    };

    function FaqGroup(root) {
      var self = this;

      this.exclusive = root.getAttribute('data-faq-exclusive') === 'true';
      this.items = [];

      Array.prototype.forEach.call(root.querySelectorAll('.faq__item'), function (el) {
        self.items.push(new FaqItem(el, self));
      });
    }

    FaqGroup.prototype.closeOthers = function (except) {
      if (!this.exclusive) return;

      this.items.forEach(function (item) {
        if (item === except || !item.el.open || item.isClosing) return;

        if (reducedMotion()) {
          item.el.open = false;
        } else {
          item.shrink();
        }
      });
    };

    function init(scope) {
      var root = scope || document;

      Array.prototype.forEach.call(root.querySelectorAll('[data-faq]'), function (el) {
        if (el.hasAttribute('data-faq-ready')) return;
        el.setAttribute('data-faq-ready', '');
        new FaqGroup(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    // Re-init when re-rendered inside the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-full-product-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSpicyHero(hero) {
      if (!hero || hero.dataset.spicyHeroInit === 'true') {
        return;
      }
      hero.dataset.spicyHeroInit = 'true';

      // No IntersectionObserver support: just reveal it.
      if (!('IntersectionObserver' in window)) {
        hero.classList.add('is-inview');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(hero);
    }

    function initAll() {
      document.querySelectorAll('.spicy-hero').forEach(initSpicyHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init when re-rendered inside the Shopify theme editor.
    document.addEventListener('shopify:section:load', function (event) {
      initSpicyHero(event.target.querySelector('.spicy-hero'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-pack-pill]');
    if (!pill) return;

    var body = pill.closest('.product-carousel__body');
    var index = pill.getAttribute('data-pack-pill');

    body.querySelectorAll('[data-pack-pill]').forEach(function (el) {
      var active = el === pill;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active);
    });

    body.querySelectorAll('[data-pack-item]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-pack-item') === index);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var AUTOPLAY_MS = 4000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initReviewsSlider(root) {
      if (!root || root.dataset.reviewsInit === 'true') return;

      var track = root.querySelector('[data-reviews-track]');
      var prev = root.querySelector('[data-reviews-prev]');
      var next = root.querySelector('[data-reviews-next]');
      if (!track || !prev || !next) return;
      root.dataset.reviewsInit = 'true';

      var timer = null;
      var paused = false;

      // one card + gap
      function step() {
        var card = track.querySelector('.product-review');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      // shift by one card; wrap around at either end
      function go(direction) {
        var max = maxScroll();
        if (max <= 1) return;

        if (direction > 0 && track.scrollLeft >= max - 1) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else if (direction < 0 && track.scrollLeft <= 1) {
          track.scrollTo({ left: max, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: direction * step(), behavior: 'smooth' });
        }
      }

      function stop() {
        clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (paused || reduceMotion.matches || document.hidden || maxScroll() <= 1) return;
        timer = setInterval(function () {
          go(1);
        }, AUTOPLAY_MS);
      }

      // a manual click restarts the countdown so the next auto-shift doesn't land right after it
      prev.addEventListener('click', function () {
        go(-1);
        start();
      });

      next.addEventListener('click', function () {
        go(1);
        start();
      });

      // hold still while someone is reading, hovering or tabbing through
      function pause() {
        paused = true;
        stop();
      }

      function resume() {
        paused = false;
        start();
      }

      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) resume();
      });
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('touchend', resume, { passive: true });

      document.addEventListener('visibilitychange', start);
      window.addEventListener('resize', start);

      start();
    }

    function initAll() {
      document.querySelectorAll('[data-reviews-slider]').forEach(initReviewsSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // re-init when the section is re-rendered inside the theme editor
    document.addEventListener('shopify:section:load', function (event) {
      initReviewsSlider(event.target.querySelector('[data-reviews-slider]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
